/*
 * Hound-Tees Labels: product-page variant sync (SPEC.md §4.2). ES2017, no dependencies.
 *
 * On variant change Sahara fetches the section and replaces only the innerHTML of
 * #Product-Price-<section id>. htl-labels.liquid ends that region with
 * <template data-htl-sync="g|t"> holding the selected variant's gallery and title labels.
 * This script copies each template into every [data-htl-target="<slot>"] of the same
 * .shopify-section (one per gallery slide, one under the title).
 */
(function () {
  "use strict";
  if (window.__htlSync) return;

  var PRICE = '[id^="Product-Price-"]';
  var timer = 0;

  function syncPrice(price) {
    var scope = price.closest(".shopify-section") || document;
    var tpls = price.querySelectorAll("template[data-htl-sync]");
    for (var i = 0; i < tpls.length; i++) {
      var slot = tpls[i].getAttribute("data-htl-sync");
      var html = tpls[i].innerHTML;
      var targets = scope.querySelectorAll('[data-htl-target="' + slot + '"]');
      for (var j = 0; j < targets.length; j++) {
        // Write only on change, so syncing never loops and never reloads images needlessly.
        if (targets[j].innerHTML !== html) targets[j].innerHTML = html;
      }
    }
  }

  function run() {
    timer = 0;
    var prices = document.querySelectorAll(PRICE);
    for (var i = 0; i < prices.length; i++) syncPrice(prices[i]);
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(run, 30);
  }

  function isElement(node) {
    return !!node && node.nodeType === 1;
  }

  // Relevant: children changed inside a price block, or an added node is or contains one.
  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var rec = records[i];
      if (isElement(rec.target) && rec.target.closest(PRICE)) return schedule();
      for (var j = 0; j < rec.addedNodes.length; j++) {
        var node = rec.addedNodes[j];
        if (isElement(node) && (node.matches(PRICE) || node.querySelector(PRICE))) return schedule();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener("shopify:section:load", schedule);
  window.__htlSync = { run: run, observer: observer };
  // Catch a price block that theme JS replaced before this deferred script ran.
  schedule();
})();
